import { useColorScheme } from '@mui/material/styles';

export type ZuulColorMode = 'light' | 'dark';
export type ZuulColorPreference = ZuulColorMode | 'system';

/**
 * Single source of truth for the app's color mode. Wraps MUI's useColorScheme and resolves
 * 'system' to the effective light/dark value so callers never see an undefined mode.
 */
export function useZuulColorMode() {
  const { mode, systemMode, setMode } = useColorScheme();
  const preference: ZuulColorPreference = mode ?? 'system';
  const resolved: ZuulColorMode = (preference === 'system' ? systemMode : preference) ?? 'light';
  return {
    mode: resolved,
    preference,
    setMode: (next: ZuulColorPreference) => setMode(next),
    toggle: () => setMode(resolved === 'dark' ? 'light' : 'dark'),
  };
}
